var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showPreloader)?_c('div',{staticClass:"preloader"},[_c('div',{staticClass:"preloader__progress",class:{animate: _vm.pageLoaded}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }